import Seo from "@common/seo"
import Logo from "@common/logo"
import ResetPasswordForm from "@common/auth/resetPasswordForm"
import { getLayout } from "components/layouts/landingSimpleLayout"
import { THEME } from "configs/theme"
import { VerticalCenterContainer } from "@common/container"
import { useTheme } from "next-themes"
import { getResetPassword } from "@common/network"

ResetPassword.getLayout = getLayout

ResetPassword.getInitialProps = async ({ query }) => {
  return { query }
}

export default function ResetPassword({ query }) {
  const { theme } = useTheme()
  return (
    <>
      <Seo title={`Reset password - ${THEME?.seo?.siteName}`} />
      <VerticalCenterContainer minusValue={"200"}>
        <div className="h-12 mx-auto mb-8 w-auto">
          <Logo
            logoObj={THEME["logo"]}
            version="icon"
            url="/"
            isDarkMode={theme == "dark"}
          />
        </div>
        <ResetPasswordForm token={query.token} submitFunction={getResetPassword} />
      </VerticalCenterContainer>
    </>
  )
}
